var CryptoJS = require("crypto-js");

/**
 * Decrypts a response using the given token ID.
 *
 * @param {Object} encObj - The encrypted response object containing the `responseData` and `token_id`.
 * @returns {string} The decrypted response as a string.
 * @throws {Error} If the decryption fails or the input is invalid.
 */
export async function getDecryptedResponse(encObj) {
  try {
    const result = CryptoJS.AES.decrypt(
      encObj.responseData,
      encObj.token_id
    ).toString(CryptoJS.enc.Utf8);

    return result;
  } catch (error) {
    throw new Error("Decryption failed. Check input object format and token ID.");
  }
}
